/*==================================================
=                 HEALTH CORE
==================================================*/

// Data WHO
let bmi05Data = null;
let bmi519Data = null;

let height05Data = null;
let weight05Data = null;
let head05Data = null;

let weightLengthData = null;
let weightHeightData = null;

// Elemen formulir
let age;
let height;
let weight;
let headCircumference;

let calculateBtn;
let resetBtn;
let modeInputs;

let ageField;
let ageLabel;
let ageHelp;
let growth05Fields;
let heightLabel;

// Panel hasil
let adultResult;
let child519Result;
let growth05Result;
let chartContainer;

// Elemen hasil BMI dewasa
let bmiValue;
let bmiCategory;
let healthyRange;
let advice;
let pointer;

/*==================================================
=                 INISIALISASI
==================================================*/

document.addEventListener("DOMContentLoaded", async function () {
    cacheElements();
    initializeUI();
    initializeEvents();
    await loadWHOData();
});

/*==================================================
=                 MEMUAT DATA WHO
==================================================*/

async function fetchJSON(url, label) {
    if (!url) {
        throw new Error(`URL ${label} tidak tersedia.`);
    }

    const response = await fetch(url);

    if (!response.ok) {
        throw new Error(
            `${label} gagal dimuat. HTTP ${response.status}.`
        );
    }

    return response.json();
}

async function loadWHOData() {
    try {
        const [
            bmi05,
            bmi519,
            height05,
            weight05,
            head05,
            weightLengthHeight
        ] = await Promise.all([
            fetchJSON(
                window.WHO_BMI05_URL,
                "BMI WHO usia 0–5 tahun"
            ),
            fetchJSON(
                window.WHO_BMI519_URL,
                "BMI WHO usia 5–19 tahun"
            ),
            fetchJSON(
                window.WHO_HEIGHT05_URL,
                "panjang atau tinggi badan WHO usia 0–5 tahun"
            ),
            fetchJSON(
                window.WHO_WEIGHT05_URL,
                "berat badan WHO usia 0–5 tahun"
            ),
            fetchJSON(
                window.WHO_HEAD05_URL,
                "lingkar kepala WHO usia 0–5 tahun"
            ),
            fetchJSON(
                window.WHO_WEIGHT_LENGTH_HEIGHT_URL,
                "berat badan menurut panjang atau tinggi badan WHO"
            )
        ]);

        bmi05Data = bmi05;
        bmi519Data = bmi519;

        height05Data = height05;
        weight05Data = weight05;
        head05Data = head05;

        weightLengthData =
            weightLengthHeight.weightLength;

        weightHeightData =
            weightLengthHeight.weightHeight;

        if (!weightLengthData || !weightHeightData) {
            throw new Error(
                "Struktur JSON berat badan menurut panjang atau tinggi badan tidak valid."
            );
        }
    } catch (error) {
        console.error(
            "Terjadi kesalahan saat memuat data WHO:",
            error
        );

        alert(
            "Sebagian data referensi WHO gagal dimuat. " +
            "Periksa nama file aset, lalu muat ulang halaman."
        );
    }
}

/*==================================================
=                 MENYIMPAN ELEMEN
==================================================*/

function cacheElements() {
    age =
        document.getElementById("bmi-age");

    height =
        document.getElementById("bmi-height");

    weight =
        document.getElementById("bmi-weight");

    headCircumference =
        document.getElementById(
            "head-circumference"
        );

    calculateBtn =
        document.getElementById(
            "bmi-calculate"
        );

    resetBtn =
        document.getElementById(
            "bmi-reset"
        );

    modeInputs =
        document.querySelectorAll(
            'input[name="mode"]'
        );

    ageField =
        document.getElementById(
            "age-field"
        );

    ageLabel =
        document.querySelector(
            'label[for="bmi-age"]'
        );

    ageHelp =
        ageField
            ? ageField.querySelector("small")
            : null;

    growth05Fields =
        document.getElementById(
            "growth05-fields"
        );

    heightLabel =
        document.getElementById(
            "height-label"
        );

    adultResult =
        document.getElementById(
            "adult-result"
        );

    child519Result =
        document.getElementById(
            "child519-result"
        );

    growth05Result =
        document.getElementById(
            "growth05-result"
        );

    chartContainer =
        document.getElementById(
            "who-chart-container"
        );

    bmiValue =
        document.getElementById(
            "bmi-value"
        );

    bmiCategory =
        document.getElementById(
            "bmi-category"
        );

    healthyRange =
        document.getElementById(
            "healthy-range"
        );

    advice =
        document.getElementById(
            "bmi-advice"
        );

    pointer =
        document.getElementById(
            "bmi-pointer"
        );
}

/*==================================================
=                 TAMPILAN AWAL
==================================================*/

function initializeUI() {
    ageField.style.display = "none";
    growth05Fields.style.display = "none";

    adultResult.style.display = "block";
    child519Result.style.display = "none";
    growth05Result.style.display = "none";

    if (chartContainer) {
        chartContainer.style.display = "none";
    }
}

/*==================================================
=                 EVENT
==================================================*/

function initializeEvents() {
    calculateBtn.addEventListener(
        "click",
        calculate
    );

    resetBtn.addEventListener(
        "click",
        resetCalculator
    );

    modeInputs.forEach(function (input) {
        input.addEventListener(
            "change",
            switchMode
        );
    });
}

/*==================================================
=                 PERGANTIAN MODE
==================================================*/

function switchMode(event) {
    const mode = event.target.value;

    hideAllResultPanels();

    if (chartContainer) {
        chartContainer.style.display = "none";
    }

    age.value = "";

    if (mode === "adult") {
        ageField.style.display = "none";
        growth05Fields.style.display = "none";

        heightLabel.textContent =
            "Tinggi Badan (cm)";

        adultResult.style.display =
            "block";

        return;
    }

    if (mode === "child519") {
        ageField.style.display = "block";
        growth05Fields.style.display = "none";

        heightLabel.textContent =
            "Tinggi Badan (cm)";

        ageLabel.textContent =
            "Usia (tahun)";

        age.min = "5";
        age.max = "19";
        age.step = "1";
        age.placeholder = "Contoh: 10";

        if (ageHelp) {
            ageHelp.textContent =
                "Masukkan usia anak dalam tahun penuh, misalnya 10.";
        }

        child519Result.style.display =
            "block";

        return;
    }

    if (mode === "growth05") {
        ageField.style.display = "block";
        growth05Fields.style.display = "block";

        heightLabel.textContent =
            "Panjang / Tinggi Badan (cm)";

        ageLabel.textContent =
            "Usia (bulan)";

        age.min = "0";
        age.max = "60";
        age.step = "1";
        age.placeholder = "Contoh: 24";

        if (ageHelp) {
            ageHelp.textContent =
                "Masukkan usia anak dalam bulan, dari 0 sampai 60 bulan.";
        }

        growth05Result.style.display =
            "block";
    }
}

function hideAllResultPanels() {
    adultResult.style.display = "none";
    child519Result.style.display = "none";
    growth05Result.style.display = "none";
}

/*==================================================
=                 PERHITUNGAN
==================================================*/

function calculate() {
    const selectedMode =
        document.querySelector(
            'input[name="mode"]:checked'
        );

    const selectedSex =
        document.querySelector(
            'input[name="sex"]:checked'
        );

    if (!selectedMode) {
        alert(
            "Silakan pilih jenis pengukuran."
        );
        return;
    }

    if (!selectedSex) {
        alert(
            "Silakan pilih jenis kelamin."
        );
        return;
    }

    const mode = selectedMode.value;
    const sex = selectedSex.value;

    const heightCm =
        parseFloat(height.value);

    const weightKg =
        parseFloat(weight.value);

    if (
        Number.isNaN(heightCm) ||
        Number.isNaN(weightKg) ||
        heightCm <= 0 ||
        weightKg <= 0
    ) {
        alert(
            "Silakan masukkan tinggi atau panjang badan dan berat badan yang valid."
        );
        return;
    }

    hideAllResultPanels();

    if (chartContainer) {
        chartContainer.style.display = "none";
    }

    // ==========================================
    // BMI Dewasa
    // ==========================================

    if (mode === "adult") {
        const result =
            calculateAdultBMI(
                heightCm,
                weightKg
            );

        adultResult.style.display =
            "block";

        updateAdultResult(result);

        return;
    }

    const ageValue =
        parseFloat(age.value);

    if (
        Number.isNaN(ageValue) ||
        ageValue < 0
    ) {
        alert(
            "Silakan masukkan usia yang valid."
        );
        return;
    }

    const heightMeters =
        heightCm / 100;

    const bmi =
        weightKg /
        (
            heightMeters *
            heightMeters
        );

    // ==========================================
    // BMI Anak Usia 5–19 Tahun
    // ==========================================

    if (mode === "child519") {
        const ageYears = ageValue;

        if (
            ageYears < 5 ||
            ageYears > 19
        ) {
            alert(
                "Pengukuran ini hanya tersedia untuk anak usia 5–19 tahun."
            );
            return;
        }

        if (!Number.isInteger(ageYears)) {
            alert(
                "Masukkan usia anak dalam tahun penuh, misalnya 10."
            );
            return;
        }

        if (!bmi519Data) {
            alert(
                "Data referensi BMI WHO masih dimuat. Silakan coba kembali."
            );
            return;
        }

        const result =
            calculateChildBMI(
                bmi,
                ageYears,
                sex,
                bmi05Data,
                bmi519Data
            );

        if (result.error) {
            alert(result.error);
            return;
        }

        child519Result.style.display =
            "block";

        updateChildResult(result);

        if (
            typeof drawChildChart ===
            "function"
        ) {
            drawChildChart(
                result,
                sex,
                bmi519Data
            );

            if (chartContainer) {
                chartContainer.style.display =
                    "block";
            }
        }

        return;
    }

    // ==========================================
    // Pertumbuhan Anak Usia 0–5 Tahun
    // ==========================================

    if (mode === "growth05") {
        const ageMonths =
            Math.round(ageValue);

        if (
            ageMonths < 0 ||
            ageMonths > 60
        ) {
            alert(
                "Pengukuran ini hanya tersedia untuk anak usia 0–60 bulan."
            );
            return;
        }

        if (!Number.isInteger(ageValue)) {
            alert(
                "Masukkan usia anak dalam jumlah bulan penuh, misalnya 24."
            );
            return;
        }

        if (
            !height05Data ||
            !weight05Data ||
            !head05Data ||
            !weightLengthData ||
            !weightHeightData
        ) {
            alert(
                "Data referensi pertumbuhan WHO masih dimuat. Silakan coba kembali."
            );
            return;
        }

        const headValue =
            parseFloat(
                headCircumference.value
            );

        const cleanHeadValue =
            Number.isNaN(headValue)
                ? 0
                : headValue;

        const inputs = {
            ageMonths: ageMonths,
            sex: sex,
            height: heightCm,
            weight: weightKg,
            head: cleanHeadValue
        };

        const datasets = {
            height: height05Data,
            weight: weight05Data,
            head: head05Data,
            weightLength:
                weightLengthData,
            weightHeight:
                weightHeightData
        };

        const results =
            calculateGrowth05(
                inputs,
                datasets
            );

        const growthError =
            hasGrowthErrors(results);

        if (growthError) {
            alert(growthError.error);
            return;
        }

        const chartConfig = {
            ageMonths: ageMonths,
            sex: sex,
            height: heightCm,
            weight: weightKg,
            head: cleanHeadValue,
            datasets: datasets
        };

        if (
            typeof setGrowthChartData ===
            "function"
        ) {
            setGrowthChartData(
                chartConfig
            );
        }

        growth05Result.style.display =
            "block";

        updateGrowth05UI(results);

        return;
    }

    alert(
        "Jenis kalkulator tidak dikenali."
    );
}

/*==================================================
=                 RESET
==================================================*/

function resetCalculator() {
    age.value = "";
    height.value = "";
    weight.value = "";
    headCircumference.value = "";

    bmiValue.textContent = "--";

    bmiCategory.textContent =
        "Masukkan data Anda";

    bmiCategory.className =
        "bmi-category";

    healthyRange.textContent = "--";

    advice.textContent =
        "Masukkan tinggi dan berat badan untuk melihat hasil perhitungan.";

    pointer.style.left = "50%";

    const childPercentile =
        document.getElementById(
            "child-percentile"
        );

    if (childPercentile) {
        childPercentile.textContent =
            "--";
    }

    if (chartContainer) {
        chartContainer.style.display =
            "none";
    }

    const selectedMode =
        document.querySelector(
            'input[name="mode"]:checked'
        );

    hideAllResultPanels();

    if (
        selectedMode &&
        selectedMode.value === "child519"
    ) {
        child519Result.style.display =
            "block";
        return;
    }

    if (
        selectedMode &&
        selectedMode.value === "growth05"
    ) {
        growth05Result.style.display =
            "block";
        return;
    }

    adultResult.style.display = "block";
}